import script from "./JobSearchDetailView.vue?vue&type=script&lang=ts&setup=true"
export * from "./JobSearchDetailView.vue?vue&type=script&lang=ts&setup=true"

import "./JobSearchDetailView.vue?vue&type=style&index=0&id=677fce84&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/jobs/MYNAVI_MP_VIEW_G_PROD/workspace/view/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-677fce84"]])

export default __exports__